import { render, staticRenderFns } from "./ProductJobBoard.vue?vue&type=template&id=346d2f94&"
import script from "./ProductJobBoard.vue?vue&type=script&lang=js&"
export * from "./ProductJobBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports